import React, { useLayoutEffect, useRef } from 'react';
import styles from './ContentResizer.module.scss';

interface ContentResizerProps {
  children?: React.ReactNode;
  maxWidth: number;
}

/**
 * Automatically scales its contents using CSS when the content overflows the max width.
 */
const ContentResizer: React.FC<ContentResizerProps> = ({ children, maxWidth }) => {
  const wrapperRef = useRef<HTMLSpanElement>(null);

  useLayoutEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return;

    const updateScale = () => {
      const scaleFactor = Math.min(1, maxWidth / (wrapper.offsetWidth || 1));
      wrapper.style.transform = scaleFactor === 1 ? 'none' : `scale(${scaleFactor})`;
    };

    updateScale();

    const observer = new ResizeObserver(updateScale);

    observer.observe(wrapper, {});
    return () => observer.disconnect();
  }, [maxWidth]);

  return (
    <div style={{ maxWidth }}>
      <span className={styles.wrapper} ref={wrapperRef}>
        {children}
      </span>
    </div>
  );
};

export default ContentResizer;
